<router-outlet />


@if (loading()) {
    <div class="app-loading">
        <pd-spinner />
    </div>
}
